<script setup lang="ts">
import { useRouter } from 'vue-router'
import { env } from '../../../config/env'

const router = useRouter()

const navigate = (route: string) => {
  router.push(route)
}
</script>

<template>
  <footer class="fixed bottom-0 md:left-64 left-0 right-0 bg-white dark:bg-black border-t border-gray-100 dark:border-gray-800 py-4 px-6">
    <div class="container mx-auto flex justify-between items-center">
      <!-- Copyright -->
      <div class="text-sm text-gray-500 dark:text-gray-400">
        © {{ new Date().getFullYear() }} {{ env.companyName }}. All rights reserved.
      </div>

      <!-- Links -->
      <div class="flex space-x-6">
        <button 
          @click="navigate('/privacy-policy')" 
          class="text-sm text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
        >
          Privacy Policy
        </button>
        <button 
          @click="navigate('/terms-conditions')" 
          class="text-sm text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
        >
          Terms & Conditions
        </button>
        <button 
          @click="navigate('/contact')" 
          class="text-sm text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
        >
          Contact Us
        </button>
        <button 
          @click="navigate('/documentation')" 
          class="text-sm text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center gap-1"
        >
          <span>📚</span>
          Documentation
        </button>
      </div>
    </div>
  </footer>
</template>
```